/* Cart Item Auto-Delivery Frequency Selector
   Handles the per-line-item "Save with Auto-Delivery" toggle and frequency
   <select> rendered by sections/custom-cart.liquid.

   Clicking the toggle immediately subscribes that line to its default
   delivery plan (2-month, falling back to the first available plan) via
   Liquid Ajax Cart — the side cart re-renders and the frequency dropdown
   then shows that plan selected, letting the shopper pick a different
   frequency or revert to One-Time Purchase from there. Changing the
   dropdown updates the real cart line item's selling plan the same way.

   A single delegated listener is used because the side cart replaces its
   inner HTML on every cart update (data-ajax-cart-section), which would
   detach any directly-bound handlers. */
(function () {
  "use strict";

  function changeSellingPlan(key, quantity, sellingPlan) {
    var lac = window.liquidAjaxCart;
    if (!lac || typeof lac.cartRequestChange !== "function") {
      console.error("Cart Item Frequency: Liquid Ajax Cart is not available");
      return;
    }

    var body = {
      id: key,
      selling_plan: sellingPlan,
    };
    if (!isNaN(quantity)) {
      body.quantity = quantity;
    }

    lac.cartRequestChange(body);
  }

  document.addEventListener("click", function (event) {
    var toggle = event.target.closest("[data-ci-freq-toggle]");
    if (!toggle) return;
    event.preventDefault();

    if (toggle.hasAttribute("disabled")) return;

    var key = toggle.getAttribute("data-ci-freq-key");
    var quantity = parseInt(toggle.getAttribute("data-ci-freq-qty"), 10);
    var defaultPlan = toggle.getAttribute("data-ci-freq-default-plan");
    if (!defaultPlan) return;

    toggle.setAttribute("disabled", "disabled");
    changeSellingPlan(key, quantity, Number(defaultPlan));
  });

  document.addEventListener("change", function (event) {
    var select = event.target.closest("[data-ci-freq-select]");
    if (!select) return;

    var key = select.getAttribute("data-ci-freq-key");
    var quantity = parseInt(select.getAttribute("data-ci-freq-qty"), 10);
    var value = select.value;

    select.setAttribute("disabled", "disabled");
    changeSellingPlan(key, quantity, value ? Number(value) : null);
  });
})();
